/* eslint-disable no-case-declarations */
import { processPrototypes, processUnits } from 'src/app/helpers/units.helper';
import { reduxUnitTypes } from 'src/types';
import {
  UPDATE_UNITS_FROM_BACKEND,
  SET_UNITS,
  ADD_UNIT,
  DELETE_UNITS,
  SITREP_UNIT_SELECT,
  SITREP_UNIT_DESELECT,
  SITREP_CHANGE_VISUAL_ACTIVE,
  CH_UNIT_SELECTED,
  ADD_COMMAND_TO_UNIT,
  REMOVE_COMMAND_FROM_UNIT,
  MISREP_COMMAND_SELECT,
  MISREP_COMMAND_DESELECT,
  COMMAND_QUEUE_COMMAND_SELECT,
  COMMAND_QUEUE_COMMAND_DESELECT,
  MISREP_UNIT_SELECT,
  MISREP_UNIT_DESELECT,
  TOGGLE_SITREP_UNIT_UNVISIBLE,
  TOGGLE_MISREP_UNIT_UNVISIBLE,
  TOGGLE_SITREP_DOCK,
  TOGGLE_MISREP_DOCK,
  TOGGLE_COMMAND_QUEUE_DOCK,
  CHANGE_SITREP_POSITION,
  CHANGE_MISREP_POSITION,
  COMMAND_QUEUE_UNIT_SELECT,
  COMMAND_QUEUE_UNIT_DESELECT,
  CHANGE_COMMAND_QUEUE_POSITION,
  RESET_COMMAND_QUEUE_SELECTED_UNITS,
  RESET_SITREP_SELECTED_UNITS,
  RESET_MISREP_SELECTED_UNITS,
  SET_LAST_ACTIVE_BAR,
  CHANGE_WEIGHT_UNIT,
  FILTER_UNITS,
  SIDES_ADDED,
  FACTIONS_ADDED,
  PROTOTYPES_ADDED,
  ADD_HLA_UNIT,
  SET_HLA_UNITS,
  SET_HLA_MAP_UNITS,
} from '../../redux-types';

export const unitsDefaultState: reduxUnitTypes.StateType = {
  units: [],
  hlaUnits: [],
  hlaMapUnits: [],
  unitToAdd: undefined,
  unitsToAdd: undefined,
  environmentalUnits: [],
  aarUnits: undefined,
  prototypes: [],
  sides: [],
  sideRelations: [],
  agents: [],
  factions: [],
  sitrepSelectedUnits: [],
  misrepSelectedUnits: [],
  commandQueueSelectedUnits: [],
  commandQueueSelectedCommand: -1,
  misrepSelectedCommands: [],
  lastActivedBar: undefined,
  weightUnit: 1,
  extraBars: [],
};

export const unitsReducer = (
  state = unitsDefaultState,
  action: reduxUnitTypes.ActionType,
): reduxUnitTypes.StateType => {
  let item;
  let index;

  switch (action.type) {
    case UPDATE_UNITS_FROM_BACKEND:
      const updatedPrototypes = [
        ...state.prototypes,
        ...processPrototypes(action.payload.prototypes || [], state.prototypes).newPrototypes,
      ];

      const { updatedUnits, updatedEnvironmentalUnits, toBeDeleted } = processUnits(
        action.payload.etmenGuncelleme,
        state.units,
        state.environmentalUnits,
        updatedPrototypes,
        state.factions,
        state.sides,
        action.payload.mesajAltTipi,
        action.payload.olaylar,
      );

      return {
        ...state,
        units: updatedUnits,
        environmentalUnits: updatedEnvironmentalUnits,
        unitsToDelete: toBeDeleted,
        prototypes: updatedPrototypes,
      };

    case SET_UNITS:
      return {
        ...state,
        units: action.payload,
      };

    case ADD_UNIT:
      if (action.payload) {
        return {
          ...state,
          unitToAdd: action.payload,
          units: [action.payload, ...state.units],
        };
      }
      return {
        ...state,
        unitToAdd: undefined,
      };

    case DELETE_UNITS:
      if (action.payload) {
        return {
          ...state,
          unitsToDelete: action.payload,
          units: state.units.filter((o) => !action.payload?.includes(o.id)),
        };
      }

      return {
        ...state,
        unitsToDelete: undefined,
      };

    case SIDES_ADDED:
      return {
        ...state,
        sides: action.payload,
      };

    case FACTIONS_ADDED:
      return {
        ...state,
        factions: action.payload,
      };

    case PROTOTYPES_ADDED:
      return {
        ...state,
        prototypes: action.payload,
      };

    case SITREP_UNIT_SELECT:
      if (state.sitrepSelectedUnits.some((o) => o.id === action.payload.unitId)) {
        // if (!state.extraBars.some((o) => o === action.payload))
        return {
          ...state,
          extraBars: [action.payload.unitId, ...state.extraBars],
        };
        // return { ...state };
      }

      return {
        ...state,
        sitrepSelectedUnits: [
          {
            id: action.payload.unitId,
            unitType: action.payload.unitType,
            sensingRangeActive: false,
            volumeActive: false,
            weaponRangeActive: false,
            timestamp: new Date().getTime(),
            isVisible: true,
            isDocked: true,
            position: {
              x: 1000,
              y: 1000,
            },
            measurements: false,
            isMisrepOpen: false,
            isCommandQueueOpen: false,
            isIntrepOpen: false,
            isComrepOpen: false,
          },
          ...state.sitrepSelectedUnits,
        ],
      };

    case SITREP_UNIT_DESELECT:
      return {
        ...state,
        sitrepSelectedUnits: state.sitrepSelectedUnits.filter((o) => o.id !== action.payload),
        extraBars: state.extraBars.filter((o) => o !== action.payload),
      };

    case SITREP_CHANGE_VISUAL_ACTIVE:
      item = state.sitrepSelectedUnits.find((o) => o.id === action.payload.id);
      index = state.sitrepSelectedUnits.findIndex((o) => o.id === action.payload.id);

      if (item && index !== undefined) {
        return {
          ...state,
          sitrepSelectedUnits: [
            ...state.sitrepSelectedUnits.slice(0, index),
            {
              ...item,
              [action.payload.key]: action.payload.bool !== undefined ? action.payload.bool : !item[action.payload.key],
            },
            ...state.sitrepSelectedUnits.slice(index + 1),
          ],
        };
      }

      return state;

    case CH_UNIT_SELECTED:
      return {
        ...state,
        chSelectedUnit: state.units.find((o) => o.id === action.payload),
      };

    case MISREP_COMMAND_SELECT:
      if (state.misrepSelectedCommands.includes(action.payload)) {
        return state;
      }

      return {
        ...state,
        misrepSelectedCommands: [...state.misrepSelectedCommands, action.payload],
      };

    case MISREP_COMMAND_DESELECT:
      return {
        ...state,
        misrepSelectedCommands: state.misrepSelectedCommands.filter((o) => o !== action.payload),
      };

    case COMMAND_QUEUE_COMMAND_SELECT:
      return {
        ...state,
        commandQueueSelectedCommand: action.payload,
      };

    case COMMAND_QUEUE_COMMAND_DESELECT:
      return {
        ...state,
        commandQueueSelectedCommand: -1,
      };

    case MISREP_UNIT_SELECT:
      if (state.misrepSelectedUnits.some((o) => o.id === action.payload)) {
        return state;
      }

      return {
        ...state,
        misrepSelectedUnits: [
          {
            id: action.payload,
            timestamp: new Date().getTime(),
            isVisible: true,
            isDocked: true,
            position: {
              x: 100,
              y: 100,
            },
          },
          ...state.misrepSelectedUnits,
        ],
      };

    case MISREP_UNIT_DESELECT:
      return {
        ...state,
        misrepSelectedUnits: state.misrepSelectedUnits.filter((o) => o.id !== action.payload),
        extraBars: state.extraBars.filter((o) => o !== action.payload),
      };

    case TOGGLE_SITREP_UNIT_UNVISIBLE:
      item = state.sitrepSelectedUnits.find((o) => o.id === action.payload);
      index = state.sitrepSelectedUnits.findIndex((o) => o.id === action.payload);

      if (item && index !== undefined) {
        return {
          ...state,
          sitrepSelectedUnits: [
            ...state.sitrepSelectedUnits.slice(0, index),
            {
              ...item,
              isVisible: !item.isVisible,
            },
            ...state.sitrepSelectedUnits.slice(index + 1),
          ],
        };
      }
      return state;
    case TOGGLE_MISREP_UNIT_UNVISIBLE:
      item = state.misrepSelectedUnits.find((o) => o.id === action.payload);
      index = state.misrepSelectedUnits.findIndex((o) => o.id === action.payload);

      if (item && index !== undefined) {
        return {
          ...state,
          misrepSelectedUnits: [
            ...state.misrepSelectedUnits.slice(0, index),
            {
              ...item,
              isVisible: !item.isVisible,
            },
            ...state.misrepSelectedUnits.slice(index + 1),
          ],
        };
      }
      return state;

    case TOGGLE_SITREP_DOCK:
      item = state.sitrepSelectedUnits.find((o) => o.id === action.payload);
      index = state.sitrepSelectedUnits.findIndex((o) => o.id === action.payload);

      if (item && index !== undefined) {
        return {
          ...state,
          sitrepSelectedUnits: [
            ...state.sitrepSelectedUnits.slice(0, index),
            {
              ...item,
              isDocked: !item.isDocked,
            },
            ...state.sitrepSelectedUnits.slice(index + 1),
          ],
        };
      }
      return state;

    case TOGGLE_MISREP_DOCK:
      item = state.misrepSelectedUnits.find((o) => o.id === action.payload);
      index = state.misrepSelectedUnits.findIndex((o) => o.id === action.payload);

      if (item && index !== undefined) {
        return {
          ...state,
          misrepSelectedUnits: [
            ...state.misrepSelectedUnits.slice(0, index),
            {
              ...item,
              isDocked: !item.isDocked,
            },
            ...state.misrepSelectedUnits.slice(index + 1),
          ],
        };
      }
      return state;

    case TOGGLE_COMMAND_QUEUE_DOCK:
      item = state.commandQueueSelectedUnits.find((o) => o.id === action.payload);
      index = state.commandQueueSelectedUnits.findIndex((o) => o.id === action.payload);

      if (item && index !== undefined) {
        return {
          ...state,
          commandQueueSelectedUnits: [
            ...state.commandQueueSelectedUnits.slice(0, index),
            {
              ...item,
              isDocked: !item.isDocked,
            },
            ...state.commandQueueSelectedUnits.slice(index + 1),
          ],
        };
      }
      return state;

    case CHANGE_SITREP_POSITION:
      item = state.sitrepSelectedUnits.find((o) => o.id === action.payload.id);
      index = state.sitrepSelectedUnits.findIndex((o) => o.id === action.payload.id);

      if (item && index !== undefined) {
        return {
          ...state,
          sitrepSelectedUnits: [
            ...state.sitrepSelectedUnits.slice(0, index),
            {
              ...item,
              position: {
                x: action.payload.position.x,
                y: action.payload.position.y,
              },
            },
            ...state.sitrepSelectedUnits.slice(index + 1),
          ],
        };
      }
      return state;

    case CHANGE_MISREP_POSITION:
      item = state.misrepSelectedUnits.find((o) => o.id === action.payload.id);
      index = state.misrepSelectedUnits.findIndex((o) => o.id === action.payload.id);

      if (item && index !== undefined) {
        return {
          ...state,
          misrepSelectedUnits: [
            ...state.misrepSelectedUnits.slice(0, index),
            {
              ...item,
              position: {
                x: action.payload.position.x,
                y: action.payload.position.y,
              },
            },
            ...state.misrepSelectedUnits.slice(index + 1),
          ],
        };
      }
      return state;

    case COMMAND_QUEUE_UNIT_SELECT:
      if (state.commandQueueSelectedUnits.some((o) => o.id === action.payload)) {
        return state;
      }

      return {
        ...state,
        commandQueueSelectedUnits: [
          ...state.commandQueueSelectedUnits,
          {
            id: action.payload,
            timestamp: new Date().getTime(),
            isVisible: true,
            isDocked: true,
            position: {
              x: 100,
              y: 100,
            },
          },
        ],
      };

    case COMMAND_QUEUE_UNIT_DESELECT:
      return {
        ...state,
        commandQueueSelectedUnits: state.commandQueueSelectedUnits.filter((o) => o.id !== action.payload),
        extraBars: state.extraBars.filter((o) => o !== action.payload),
      };

    case CHANGE_COMMAND_QUEUE_POSITION:
      item = state.commandQueueSelectedUnits.find((o) => o.id === action.payload.id);
      index = state.commandQueueSelectedUnits.findIndex((o) => o.id === action.payload.id);

      if (item && index !== undefined) {
        return {
          ...state,
          commandQueueSelectedUnits: [
            ...state.commandQueueSelectedUnits.slice(0, index),
            {
              ...item,
              position: {
                x: action.payload.position.x,
                y: action.payload.position.y,
              },
            },
            ...state.commandQueueSelectedUnits.slice(index + 1),
          ],
        };
      }
      return state;

    case RESET_COMMAND_QUEUE_SELECTED_UNITS:
      return {
        ...state,
        commandQueueSelectedUnits: [],
        extraBars: [],
      };

    case RESET_SITREP_SELECTED_UNITS:
      return {
        ...state,
        sitrepSelectedUnits: [],
        extraBars: [],
      };

    case RESET_MISREP_SELECTED_UNITS:
      return {
        ...state,
        misrepSelectedUnits: [],
        extraBars: [],
      };

    case SET_LAST_ACTIVE_BAR:
      return {
        ...state,
        lastActivedBar: {
          id: action.payload.id,
          type: action.payload.type,
        },
      };
    case CHANGE_WEIGHT_UNIT:
      return {
        ...state,
        weightUnit: action.payload,
      };
    case ADD_HLA_UNIT:
      const incoming = action.payload;

      const existingIndex = state.hlaUnits.findIndex((item) => item.uuid === incoming.uuid);

      if (existingIndex !== -1) {
        const updatedItems = [...state.hlaUnits];
        updatedItems[existingIndex] = incoming;
        return {
          ...state,
          hlaUnits: updatedItems,
        };
      } else {
        return {
          ...state,
          hlaUnits: [...state.hlaUnits, incoming],
        };
      }

    case SET_HLA_MAP_UNITS:
      return {
        ...state,
        hlaMapUnits: action.payload,
      };

    case SET_HLA_UNITS:
      return {
        ...state,
        hlaUnits: action.payload,
      };

    default:
      return state;
  }
};
